import React, { FC, useEffect, useState } from 'react'

import { Layout } from 'react-admin'

// import { parseURLParams } from 'shared/helpers';
import { AppBar } from '../AppBar'
import { CustomLayoutHeader } from './Header'
import Menu from '../menu'
// import WelcomeMessage from './welcome';

export type BreadcrumbType = { path?: string[]; label?: string }
export type SetLayoutBreadcrumbType = (breadcrumb: BreadcrumbType) => void

export const SetLayoutBreadcrumbContext = React.createContext<SetLayoutBreadcrumbType>(null)

const CustomLayout: FC = ({ children, ...props }): JSX.Element => {
  const [breadcrumb, setBreadcrumb] = useState<BreadcrumbType>(null)

  // const [visible, setVisible] = useState<boolean>(false);

  // Determine if Welcome Message Modal is Open
  // const params = parseURLParams([{ key: 'welcome' }]);
  // const welcomeMessageVisible = params['welcome'] === 'true';

  // useEffect(() => {
  //   setVisible(welcomeMessageVisible);
  // }, [welcomeMessageVisible]);

  const updateBreadcrumb = ({ path, label }: BreadcrumbType): void => {
    const newBreadcrumb: BreadcrumbType = {}
    if (path) newBreadcrumb.path = path
    if (label) newBreadcrumb.label = label

    setBreadcrumb((prevBreadcrumb) => ({ ...prevBreadcrumb, ...newBreadcrumb }))
  }

  return (
    <SetLayoutBreadcrumbContext.Provider value={updateBreadcrumb}>
      <Layout {...props} title="Dashboard" appBar={AppBar} menu={Menu}>
        <>
          <CustomLayoutHeader breadcrumb={breadcrumb} />
          {children}
        </>
      </Layout>
      {/* <WelcomeMessage setVisible={setVisible} visible={visible} /> */}
    </SetLayoutBreadcrumbContext.Provider>
  )
}

export default CustomLayout
